export default "__VITE_ASSET__CPOi6PCo__"